/* Angular Stuff*/
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

/* Our Own Stuff*/
import { LangService } from 'src/app/core/services/lang.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-hr-business-unit',
  templateUrl: './../../../templates/forms/modals/advance-search.component.html',
})
export class AdvanceSearchComponent implements OnInit {
  tabList = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  showTab = this.tabList[0];

  @Input()
  modalShow: boolean = true;

  @Input()
  externalValue: number;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj:any; 

  toggleShowTab(index) {
    this.showTab = index;
  }

  businessUnitList:any[] = [];
  searchFields:any[] = ['BU_NAME'];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService) { 
    }

  ngOnInit() {  
  } 

} 